import { h, Component } from 'preact';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getOptions, clone, replaceAll } from '../../../utilities/common';
import { setTrygTealium } from '../../../utilities/tracking';

// Components
import Label from '../../Form/Label';
import Description from '../../Form/Description';
import { actionHandler } from '../../../utilities/form/formUtils';
import { userDataChangeAction } from '../../../actions/UserData';

class InputSelect extends Component {
  constructor(props) {
    super(props);
    const {
      placeholder,
      loading,
      userData,
      id,
      translations,
    } = props;
    this.state = {
      placeholderState:
        replaceAll(loading, translations, userData) ||
        replaceAll(placeholder, translations, userData),
      value: userData[id] ? userData[id] : '',
      options: [],
    };
  }

  componentDidMount() {
    const {
      initialValues,
      userData,
      dispatch,
      options,
      optionsFrom,
      setFieldValue,
      id,
      setValues,
      textName,
    } = this.props;

    getOptions(
      dispatch,
      options,
      optionsFrom,
      initialValues,
      userData
    ).then(data => {
      const { placeholderState } = this.state;
      let dataForRender = Array.isArray(data) && data.length > 0 ? data : [];
      if (Array.isArray(data) && data.length > 0 && typeof data[0] !== 'object') {
        dataForRender = data.reduce((result, item) => {
          return [
            ...result,
            {
              key: item,
              value: item,
            },
          ];
        }, []);
      }
      this.setState({
        options: dataForRender,
        placeholderState,
      });

      if (!placeholderState && !this.state.value
        && dataForRender && dataForRender.length > 0) {
        this.state.value = dataForRender[0].key;
        this.setState({
          value: dataForRender[0].key,
        });
      }
      if (setFieldValue && dataForRender && this.state.value) {
        const name = textName || `${[id]}Text`;
        const details = `${[id]}Details`;
        const preSelectedData = dataForRender.reduce((result, item) => {
          return item.key === this.state.value ? item : result;
        }, {});
        if (preSelectedData.key !== undefined) {
          setFieldValue(id, preSelectedData.key);
        } else {
          // This is added because we didn't find the value in the list.
          console.warn('Can\'t find value "' + this.state.value + '" in list.', clone(dataForRender)); // eslint-disable-line
          dataForRender.unshift({
            key: this.state.value,
            value: this.state.value,
          });
        }
        let value = preSelectedData.textValue ? preSelectedData.textValue : preSelectedData.value;
        value = value || this.state.value;
        dispatch(userDataChangeAction(
          {
            fields: [
              {
                field: id,
                value: this.state.value ? this.state.value : dataForRender[0].key,
              },
              {
                field: name,
                value,
              },
              {
                field: details,
                value: preSelectedData.details,
              },
            ],
            setValues,
            setFieldValue,
          }
        ));
      }
    });
  }

  onChangeHandler(event) {
    const {
      id,
      onChange,
      actions,
      dispatch,
      setValues,
      setFieldValue,
      values,
      tealiumMap,
      textName,
    } = this.props;
    const name = textName || `${[id]}Text`;
    const details = `${[id]}Details`;
    const { options } = this.state;
    const nameValue = options.reduce((result, option) => {
      if (option.key === event.target.value) {
        setFieldValue(name, option.textValue ? option.textValue : option.value);
        return {
          text: option.textValue ? option.textValue : option.value,
          details: option.details,
        };
      }
      return result;
    }, { text: event.target.options[event.target.selectedIndex].text });

    if (tealiumMap) {
      const trackingData = {
        [tealiumMap]: nameValue.text,
      };
      setTrygTealium(trackingData);
    }

    if (actions.length > 0) {
      actionHandler(
        actions,
        onChange,
        event,
        dispatch,
        values,
        setValues,
        {
          [id]: event.target.value,
          [name]: nameValue.text,
          [details]: nameValue.details,
        }
      );
    } else {
      onChange(event);
      setFieldValue(name, nameValue.text);
      setFieldValue(details, nameValue.details);
    }
  }

  render() {
    const {
      id,
      desc,
      label,
      columns,
      formColumns,
      labelColumns,
      className,
      type,
      multiple,
      onBlur,
      required,
      dispatch,
      placeholder,
      labelActions,
      wrapperType: WrapperType,
      translations,
      values,
      setValues,
    } = this.props;
    const { placeholderState, value, options } = this.state;

    const formFieldClass = classNames(
      'form__field', {
        [`form__field--${id}`]: id,
        [`form__field--${type}`]: type,
        [`form__field--${columns}col`]: columns,
        [`form__field--${className}`]: className,
      }
    );
    const formLabelClass = classNames(
      'form__label', {
        [`form__field--${labelColumns}col`]: labelColumns,
        [`form__label--${className}`]: className,
        [`form__${className}`]: className,
      }
    );
    const formElementClass = classNames(
      'form__item', {
        [`form__field--${formColumns}col`]: formColumns,
        [`form__item--${className}`]: className,
        [`form__${className}`]: className,
        [`${className}`]: className,
      }
    );
    const labelProps = {
      actions: labelActions,
      dispatch,
      values,
      setValues,
    };
    return (
      <WrapperType className={formFieldClass}>

        {/* Label */}
        {label &&
        <Label
          label={label}
          className={formLabelClass}
          {...labelProps}
        />
        }

        {/* Input Field */}
        <select
          className={formElementClass}
          id={id}
          onChange={e => this.onChangeHandler(e)}
          onBlur={onBlur}
          multiple={multiple}
          required={required}
        >
          {((placeholderState && options && options.length === 0) || placeholder) &&
          <option value=''>
            {options && options.length === 0 ?
              placeholderState :
              replaceAll(placeholder, translations, values)
            }
          </option>
          }
          {options && options.map(option => {
            const selected = value === option.key ? 'selected' : '';
            return <option value={option.key} selected={selected}>{option.value}</option>;
          })}
        </select>

        {/* Description */}
        {desc &&
        <Description desc={desc}/>
        }

      </WrapperType>
    );
  }
}

export default compose(
  connect(state => {
    const {
      section: {
        packageData: {
          translations,
        },
      },
    } = state;
    return {
      translations,
    };
  })
)(InputSelect);

InputSelect.defaultProps = {
  desc: null,
  label: null,
  placeholder: null,
  loading: null,
  multiple: false,
  required: false,
  actions: [],
  formColumns: '',
  labelColumns: '',
  className: '',
  labelActions: null,
  wrapperType: 'div',
  tealiumMap: null,
  textName: null,
};

InputSelect.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  options: PropTypes.string.isRequired,
  optionsFrom: PropTypes.string.isRequired,
  columns: PropTypes.string.isRequired,
  formColumns: PropTypes.string,
  labelColumns: PropTypes.string,
  userData: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  actions: PropTypes.object,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
  desc: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  loading: PropTypes.string,
  className: PropTypes.string,
  setValues: PropTypes.func.isRequired,
  labelActions: PropTypes.object,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  wrapperType: PropTypes.string,
  tealiumMap: PropTypes.string,
  translations: PropTypes.object.isRequired,
  textName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Steps/Input/Select.jsx